const errorStampComponentDefinition = {
    template: '<div class="dpStampIcon dpStampIcon--error"></div>',
};

module.exports = errorStampComponentDefinition;



// WEBPACK FOOTER //
// ./src/wallet/error/digital-pay-error-stamp.component.js